import SalonBusinessCpaTopicPage from "./SalonBusinessCpaTopicPage";

export default function SalonBusinessCpaDocuments() {
  return (
    <SalonBusinessCpaTopicPage
      title="Documents"
      description="Start with the records your accountant will need most often. Uploads will be added in the next portal phase."
      sections={[
        {
          title: "Monthly records",
          body: "Keep routine salon records ready for bookkeeping review.",
          items: ["Bank statements", "Credit card statements", "Point-of-sale deposits"],
        },
        {
          title: "Payroll records",
          body: "Collect staff and contractor payment support.",
          items: ["Pay stubs", "Remittance notices", "Contractor payment summaries"],
        },
        {
          title: "Tax records",
          body: "Organize year-end and filing support in one place.",
          items: ["GST/HST filings", "CRA letters", "Owner tax slips"],
        },
      ]}
    />
  );
}
